<template>
  <div class="stamp_cnt_wrap">
    <span class="_sp-icon arrow left" ref="left" v-bind:class="{'inactive': prev }" v-on:click="setPage(page -= 1)"></span>
    <span class="stamp_cnt" v-bind:class="{'check': n <= stampCount }" v-for="n in pageSize"></span>
    <span class="_sp-icon arrow right" ref="right" v-bind:class="{'inactive': next }" v-on:click="setPage(page += 1)"></span>
  </div>
</template>

<script>
    export default {
      name: "stamp-page",
      props:[
        'totalCount',
        'stampAmount'
      ],
    data() {
      return {
        pageSize : 5,
        page : 1,
        visible: false,
        perLinks: 5,
        pageName: 'page',
        first: '',
        last: '',
        prev: true,
        next: true,
        pageList: [],
        pages: '',
        Offset: '',
        skip: '',
        index: 0,
        start: 0,
      }
    },
    created() {
      this.getPages();
    },
    methods: {
      setPage(page){

        if (page > this.pages) {
          page = this.pages;
        }

        this.page = page
      },
      getPages() {
        let page = this.page;
        let totalCount = this.totalCount;

        if (page < 1) {
          page = 1;
        }

        if (totalCount < 1) {
          totalCount = 1;
        }

        if (this.perLinks < 1) {
          this.perLinks = totalCount + 1;
        }

        if (parseInt(this.pageSize) <= 0) {
          this.pageSize = 20;
        }

        /*--------  전체 페이지 수 구하기 --------*/
        this.pages = parseInt(totalCount / this.pageSize);

        // 전체 페이지 수가 1보다 작은 경우 전체 페이지수는 1개
        if (this.pages < 1) {
          this.pages = 1;
        }

        // 마지막 페이지의 게시물 수의 나머지 값이 있는 경우 전체 페이지 수 증가
        if ((totalCount > this.pageSize) && (totalCount % this.pageSize) > 0) {
          this.pages += 1;
        }

        // 전체 게시물 수가 없는 경우 현재 페이지는 1page
        if (totalCount < 1 || page < 1) {
          page = 1;
        } else if (page > this.pages) {
          // 전체 페이지수를 넘는 경우
          page = this.pages;
        }

        //baseUrl
        this.baseUrl = this.baseUrl + '?';

        /*--------  Offset 구하기 --------*/
        this.start = (page - 1) * this.pageSize;

        /*--------  처음, 마지막 페이지 구하기 --------*/
        if (this.pages > this.perLinks) {
          if (page > this.perLinks) {
            // 처음 페이지
            this.first = 1;
          }
          if ((this.pages - page) > this.perLinks) {
            //마지막 페이지
            this.last = this.pages;
          }
        }

        // 처음 페이지
        if (page > 0 && totalCount > this.pageSize) {
          this.first = 1;
        }

        //마지막 페이지
        if ((this.pages - page) > 0 && totalCount > this.pageSize) {
          this.last = this.pages;
        }

        // 이전 페이지
        this.prev = (page - 1) <= 0;

        // 다음 페이지
        this.next = true;
        if (page + 1 <= this.pages) {
          this.next = false
        }

        this.nInspire = ((parseInt((page - 1) / this.perLinks)) * this.perLinks) + 1;
        if (this.nInspire < 1) {
          this.nInspire = 1;
        }

        this.nExpire = this.nInspire + this.perLinks - 1;
        if (this.nExpire >= this.pages) {
          this.nExpire = this.pages;
        }

        this.pageList = [];
        for (this.nIndex = this.nInspire; this.nIndex <= this.nExpire; this.nIndex++) {
          this.pageList.push(this.nIndex);
        }

        this.index = totalCount - this.start;

      },
    },
    computed: {
      stampCount() {
        if (this.page <= 1) {
          return this.stampAmount
        }

        if (this.page < this.pages) {
          return this.pageSize
        } else {
          return this.totalCount - (this.pageSize * (this.page - 1))
        }

      },
    },
    watch: {
      totalCount(to, from) {
        this.getPages();
      },
      page(to, from) {
        this.getPages();
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/mypage/stamp-page.vue